export default function WhatsAppButton() {
  const phone = "917575873232";
  const message = encodeURIComponent("Hello Pranav Logistics! I would like to inquire about your services.");
  const url = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.128 6.744 3.046 9.378L1.054 31.39l6.2-1.966A15.9 15.9 0 0016.004 32C24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.31 22.606c-.39 1.1-1.932 2.014-3.168 2.282-.846.18-1.95.324-5.67-1.218-4.762-1.974-7.826-6.806-8.064-7.12-.23-.314-1.932-2.574-1.932-4.908s1.222-3.484 1.656-3.96c.434-.478.948-.598 1.264-.598.314 0 .632.004.908.016.29.014.682-.112 1.068.814.39.948 1.338 3.27 1.456 3.508.118.236.198.514.04.828-.158.314-.236.51-.472.786-.236.274-.498.614-.71.824-.236.236-.482.494-.208.968s1.222 2.016 2.624 3.268c1.802 1.612 3.32 2.112 3.794 2.348.472.236.75.198 1.026-.118.274-.316 1.182-1.378 1.498-1.852.314-.472.632-.394 1.066-.236.434.158 2.756 1.3 3.228 1.536.472.236.788.354.906.55.118.196.118 1.14-.272 2.24z"/>
      </svg>
    </a>
  );
}
